export default [
	{  // 报工质检列表
		path: 'quality_output',
		name: 'm_quality_output',
		meta: {
			templateManage: {
				workType: 42,
				print: 'b_quality_output_printtemplate',
				export: 'b_quality_output_exporttemplate'
			},
			appView: {
				viewId: '90026',
				auth: 'b_quality_output_viewmanage',
				detailView: [{
					name: '详情-处理信息列表',
					viewId: '90028'
				}],
			}
		},
		props: route => route.query,
		component: () => import('@/pages/quality/quality_output_list')
	},
	{  // 报工质检处理列表
		path: 'quality_output_after',
		name: 'm_quality_output_after',
		meta: {
			templateManage: {
				workType: 43,
				print: 'b_quality_output_after_printtemplate',
				export: 'b_quality_output_after_exporttemplate'
			},
			appView: {
				viewId: '90027',
				auth: 'b_quality_output_after_viewmanage'
			}
		},
		props: route => route.query,
		component: () => import('@/pages/quality/quality_output_after_list')
	},
	{  // 生产入库检列表
		path: 'quality_work',
		name: 'm_quality_work',
		meta: {
			templateManage: {
				workType: 45,
				print: 'b_quality_work_printtemplate',
				export: 'b_quality_work_exporttemplate'
			}
		},
		props: route => route.query,
		component: () => import('@/pages/quality/quality_work_list')
	},
	{  // 生产入库检处理列表
		path: 'quality_work_after',
		name: 'm_quality_work_after',
		meta: {
			templateManage: {
				workType: 47,
				print: 'b_quality_work_after_printtemplate',
				export: 'b_quality_work_after_exporttemplate'
			}
		},
		props: route => route.query,
		component: () => import('@/pages/quality/quality_work_after_list')
	},
];